// ---------------------------------------------------------------------------
// The app's routes, as data (R12c)
//
// The nine paths are set from outside: every email footer links to
// /optout?email=… (server/helpers/opt-out-footer.ts), Unipile sends people
// back to /connected?provider=…&status=… (routes/accounts.ts), and 2.0's
// freeze redirect forwards its URLs byte for byte
// (routes/migration-source.ts). Matching is exact and case-sensitive; a
// trailing slash is the same route (match.ts).
//
// This module imports nothing, so the router core (router.ts), the tests and
// public-routes.ts's guard can all read it without loading a page. Which
// route renders which page is sdr-router.ts's; which routes need no user is
// public-routes.ts's, keyed by these names.
// ---------------------------------------------------------------------------

export interface RouteDef {
  /** The path pattern: literal segments and `:name` params, one segment each. */
  readonly path: string;
  /** The page's name in the browser tab (page-change.ts adds the app's name). */
  readonly title: string;
  /** 'app': in the app's frame; 'none': the page brings its own layout. */
  readonly frame: 'app' | 'none';
}

export type RouteTable = Readonly<Record<string, RouteDef>>;

export const ROUTES = {
  // The tab says Overview, as the nav does (R12d, d5).
  dashboard: { path: '/', title: 'Overview', frame: 'app' },
  newCampaign: { path: '/campaign/new', title: 'New Campaign', frame: 'app' },
  editCampaign: { path: '/campaign/:campaignId/edit', title: 'Edit Campaign', frame: 'app' },
  campaignDetail: { path: '/campaign/:campaignId/detail', title: 'Campaign', frame: 'app' },
  settings: { path: '/settings', title: 'Settings', frame: 'app' },
  // Internal, behind the assessmentAgent flag (NDI-239 v2); nothing outside links here.
  assessment: { path: '/assessment', title: 'Assessment', frame: 'app' },
  optOut: { path: '/optout', title: 'Unsubscribe', frame: 'none' },
  adminLogin: { path: '/admin/login', title: 'Admin Login', frame: 'none' },
  admin: { path: '/admin', title: 'Admin', frame: 'none' },
  // Opens in the provider's popup: no nav, no Sign out there (R12d, d2).
  connected: { path: '/connected', title: 'Connected', frame: 'none' },
} as const satisfies RouteTable;

export type RouteName = keyof typeof ROUTES;
